import { GET_ROLESANDPERMISSIONS, GET_SUPPLIERROLE } from "resources/actionTypes";

const initialRolesAndPermissionsState = {
  loading: false,
  error: null,
  rolesAndPermissions: [],
};

const initialSupplierRole = {
  loading:false,
  error:null,
  roles:[],
}

export const getRolesAndPermissions = (
  state = initialRolesAndPermissionsState,
  action
) => {

  switch (action.type) {
    case GET_ROLESANDPERMISSIONS.GET_ROLESANDPERMISSIONS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ROLESANDPERMISSIONS.GET_ROLESANDPERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        rolesAndPermissions: action.rolesAndPermissions,
      };
    case GET_ROLESANDPERMISSIONS.GET_ROLESANDPERMISSIONS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getSupplierRole = (
  state = initialSupplierRole,
  action
) => {

  switch (action.type) {
    case GET_SUPPLIERROLE.GET_SUPPLIERROLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_SUPPLIERROLE.GET_SUPPLIERROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: action.supplierRoles,
      };
    case GET_SUPPLIERROLE.GET_SUPPLIERROLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};
